import { Component, OnInit } from '@angular/core';
import { SaPaypalServiceService } from '../../services/SaPaypalService.service';

@Component({
  selector: 'app-transaction-history-combined',
  templateUrl: './transaction-history-combined.component.html',
  styleUrls: ['./transaction-history-combined.component.css']
})
export class TransactionHistoryCombinedComponent implements OnInit {
  selectedCategory: string = '2';
  showPaypal: boolean;
  showOverlayCombined: boolean;
  selectedOption: string = '2';

  addUserClick: boolean = false;
  updateDeleteUserClick: boolean = false;
  updateName: string = '';
  updateEmail: string = '';
  AlertText: string;
  ShowAlert: boolean;
  AlertAction: string;

  constructor(private _service: SaPaypalServiceService) { }

  ngOnInit() {
    this.selectedOption = '2';
    this.showOverlayCombined = true;
    this.selectedCategory = '2';
    this.changeCategory(this.selectedCategory);
  }

  changeCategory(category) {
    this.selectedOption = category == '1' ? '1' : '2';
    this.showPaypal = category == '1' ? true : false;
    this.showOverlayCombined = false;
  }

  AlertClose() {
    setTimeout(() => {
      this.ShowAlert = false;
    }, 6000);
  }

}
